import script from "./insure_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./insure_detail.vue?vue&type=script&setup=true&lang=js"

import "./insure_detail.vue?vue&type=style&index=0&id=339704c9&lang=scss"

const __exports__ = script;

export default __exports__